import React from 'react';
import StatusTableFilter from '../components/ui/StatusTableFilter/StatusTableFilter';
import {
  houseStagesColorsMap,
  addressStagesColorsMap,
} from '../constants/stagesColorMaps';

const getValueByPath = (obj, path) =>
  path.split('.').reduce((acc, key) => acc?.[key], obj);

const setMapItem = ({ mapObj, item, nameKey, idKey }) => {
  const name = item[nameKey];
  const id = item[idKey];

  if (id && name) {
    const stage = mapObj.get(id);

    stage
      ? mapObj.set(id, { ...stage, count: stage.count + 1 })
      : mapObj.set(id, { name, id, count: 1 });
  }
};

const setMapItemWithPath = ({ mapObj, item, idKey, nameKey }) => {
  const id = getValueByPath(item, idKey);
  const name = getValueByPath(item, nameKey);

  if (id && name) {
    if (mapObj.has(id)) {
      const existingItem = mapObj.get(id);
      existingItem.count += 1;
    } else {
      mapObj.set(id, {
        id,
        name,
        count: 1,
      });
    }
  }
};

const transformMapToSortArr = (mapObj, colorsMap) =>
  Array.from(mapObj.values())
    .sort((a, b) => b.count - a.count)
    .map((item) => ({
      value: item.name,
      text: (
        <StatusTableFilter
          stageCount={item.count}
          stageName={item.name}
          indicatorBgColor={colorsMap ? colorsMap.get(item.id) : undefined}
        />
      ),
    }));

export const generateHouseStageFilters = (houses) => {
  const stagesMap = new Map();

  houses.forEach((house) =>
    setMapItem({
      mapObj: stagesMap,
      item: house,
      idKey: 'houseStageId',
      nameKey: 'houseStageName',
    })
  );

  return transformMapToSortArr(stagesMap, houseStagesColorsMap);
};

export const generateHouseTypeFilters = (houses) => {
  const typesMap = new Map();

  houses.forEach((house) =>
    setMapItemWithPath({
      mapObj: typesMap,
      item: house,
      idKey: 'type.id',
      nameKey: 'type.name',
    })
  );

  return transformMapToSortArr(typesMap);
};

export const generateHouseRegionFilters = (houses) => {
  const regionsMap = new Map();

  houses.forEach((house) =>
    setMapItem({
      mapObj: regionsMap,
      item: house,
      idKey: 'regionId',
      nameKey: 'regionName',
    })
  );

  return transformMapToSortArr(regionsMap);
};

export const generateFlatStageFilters = (flats) => {
  const stagesMap = new Map();
  const acceptanceResultsMap = new Map();
  const flatTypesMap = new Map();

  const setMapItem = ({ mapObj, item, idKey, nameKey }) => {
    const id = getValueByPath(item, idKey);
    const name = getValueByPath(item, nameKey);

    if (
      mapObj === acceptanceResultsMap &&
      ![2, 3].includes(
        getValueByPath(item, 'addressLifeCycle.stageAddressLifeCycle.id')
      )
    ) {
      return;
    }

    if (id && name) {
      if (mapObj.has(id)) {
        const existingItem = mapObj.get(id);
        existingItem.count += 1;
      } else {
        mapObj.set(id, {
          id,
          name,
          count: 1,
        });
      }
    }
  };

  flats.forEach((flat) => {
    setMapItem({
      mapObj: stagesMap,
      item: flat,
      idKey: 'addressLifeCycle.stageAddressLifeCycle.id',
      nameKey: 'addressLifeCycle.stageAddressLifeCycle.name',
    });

    setMapItem({
      mapObj: acceptanceResultsMap,
      item: flat,
      idKey: 'addressLifeCycle.acceptanceStatusAddressLifeCycle.id',
      nameKey: 'addressLifeCycle.acceptanceStatusAddressLifeCycle.name',
    });

    setMapItem({
      mapObj: flatTypesMap,
      item: flat,
      idKey: 'address.typeId',
      nameKey: 'address.typeName',
    });
  });

  const stages = transformMapToSortArr(stagesMap, addressStagesColorsMap);
  const results = transformMapToSortArr(acceptanceResultsMap);
  const flatTypes = transformMapToSortArr(flatTypesMap);

  return { stages, results, flatTypes };
};
